import React, { Component } from "react";
import { TYPE_PC, TYPE_SP } from "../../common/defines";
import { modal } from "../modal";
import api from "../../lib/api";
import classnames from "classnames";

import { applyRoom } from "../../pages/area/util";
import masterData from "../../lib/masterData";

export const modal_madori = props => {
  const { room, asset, type, floorId } = props;
  const pref = masterData.pref.byId[asset.pref];
  const prefSlug = pref ? pref.slug : '';
  const setZoom = () => {
    if(type == TYPE_SP){
      let naturalWidth = document.getElementById('modal_madori_img').naturalWidth;
      let actualWidth = 303;
      if (window.matchMedia( "(min-width: 768px) and (max-width: 1024px)" ).matches) {
        actualWidth = 400;
      } else {
        actualWidth = 303;
      }
      document.getElementById('madori_box_container').style.zoom = actualWidth / naturalWidth;
    }
  }
  const roomLabel = (room) => {
    if (room.flTxt) {
      return (
        <span className="roomItemHeaderRight">{room.flTxt.replace(/[（）]/g, '')}</span>
      );
    } else if (room.productTypeTxt) {
      return (
        <span className="roomItemHeaderRight">{room.productTypeTxt.replace(/[（）]/g, '')}</span>
      );
    } else {
      return null;
    }
  }
  return (
    <div className="modal_madori modal_base">
      <div className="cross" onClick={() => modal.closeModal()} />
      <div className="img_container madoriImg">
        <img id="modal_madori_img" src={api.madorizuImageUrl(room.floorImg)} onLoad={setZoom} />
        <div id="madori_box_container">
          <div className={ room.campaignPrice ? "aki_c" : "aki" } key={room.roomId}>
            <div style={room.style}/>
          </div>
        </div>
      </div>
      <div className="infomation">
        <div>
          <div className="item">
            <span>使用料</span>
            <span>{room.price}円</span>
          </div>
          <div className="item">
            <span>広さ</span>
            <span>{room.extentName}</span>
          </div>
        </div>
        <div>
          <div className="item" style={{ "white-space": "nowrap" }}>
            <span>階数</span>
            {roomLabel(room)}<span>{room.floor}階</span>
          </div>
          <div className="item">
            <span>寸法</span>
            <span>
              {room.width}×{room.depth}×{room.height}
            </span>
          </div>
        </div>
        {room.devBiko && <div>
          <div className="item">
            <span>備考</span>
            <span>{room.devBiko}</span>
          </div>
        </div>}
      </div>
      {room.opimages.length != 0 && 
      <div className="infomation">
        <div>
            <div className="item">            
              <span>写真</span>
              <ul>
                {room.opimages.map((opimage,index) => {
                    return(
                      <li className="roomImg">
                        <img src={api.roomOpImageUrl(asset.assetId, room.roomId, opimage)}/>
                        {room.opimagesComment[index] && 
                          <p>{room.opimagesComment[index]}</p>
                        }
                      </li>
                    );
                  })
                }   
              </ul>             
            </div>
        </div>
      </div>}
      <div className="collection">
        {room.vacant == 0 &&
        <div
          className="item link"
          onClick={() => {
            applyRoom(room, asset, type, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0);
          }}
        >
          お申し込み
        </div>}
        {!asset.disableEstimation &&
        <div
          className="item link button_estimation"
          onClick={() => modal.openModal("modal_estimate", { room, asset })}
        >
          見積もり
        </div>}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./common/modal/modal_madori.jsx